__turbopack_context__.v({
  "TwoColumnModule": "iZxz7a_TwoColumnModule",
  "TwoColumnModule__Column": "iZxz7a_TwoColumnModule__Column",
  "TwoColumnModule__Text": "iZxz7a_TwoColumnModule__Text",
  "TwoColumnModule__Title": "iZxz7a_TwoColumnModule__Title",
});
